import store from "@common/js/store";
import { BarTypeEnum, ChartMode, DataPointShape, FSHADER_SOURCE, PluginMode, VSHADER_SOURCE } from "./Dh-webchart-models";
import DrawApi from "./Dh-webchart-drawApis";
import $ from "jquery";
import dayjs from "dayjs";
import { isIterable, guid, i18nGlobal, getTextSize } from "@common/js/utils";
import performanceWorker from "@core/graphs/worker/dh-performance-worker.js?worker";
//图表控件基本元素
export class ChartElement {
	//构造函数
	constructor() {
		//图表上下文，能用来获取图表相关的所有信息
		this.ChartContext = null;
		this.Id = guid();
	}
	//测量
	OnMeasure() { }
	//呈现
	OnRender() { }
	//图表发生改变
	OnChartChanged() {
		this.OnMeasure();
		this.OnRender();
	}
	//清除
	OnClear() { }
}

/**图形基本元素 */
export class ShapeElement extends ChartElement {
	//构造函数
	constructor() {
		super();
		this.Data = new Object();
	}
	OnClear() { }
	SetOption() { }
}

export class CommonShape extends ShapeElement {
	constructor() {
		super();
		this.ZoomFactor = 2;
		this.drawApi = new DrawApi();
	}
	/**确认容器已经创建 */
	EnsureContainerCreated() {
		const container = this.ChartContext.PluginContainer;
		let element = document.getElementById(this.Id);
		if (element == null) {
			element = document.createElement("canvas");
			element.setAttribute("id", this.Id);
			element.setAttribute("style", "position:absolute;left:" + this.ChartContext.CoordinateSystem.CanvasLeft + "px;z-index:1;pointer-events:none;");
			container.before(element);
		}
		const { width, height } = this.GetContainerRect();
		element.width = width * this.ZoomFactor;
		element.height = height * this.ZoomFactor;
		element.style.width = width + "px";
		element.style.height = height + "px";
		this.EnsureContainerCliped(this.Id);
		return element;
	}
	//确认容器已经剪裁
	EnsureContainerCliped() {
		const rect = this.ChartContext.Information.ShapeContainerRect;
		this.drawApi.SetContext(this.Id);
		this.drawApi.ClipRect(rect.Left * this.ZoomFactor, rect.Top * this.ZoomFactor, rect.Width * this.ZoomFactor, rect.Height * this.ZoomFactor);
	}
	/**清除 */
	OnClear() {
		if (this.drawApi.DrawContext) {
			this.drawApi.Dispose();
		}
		this.drawApi = null;
	}
	GetContainerRect() {
		const container = $("#" + this.ChartContext.ChartContainer.id);
		return {
			width: container.width(),
			height: container.height()
		}
	}
}

export class LineShapeOperator extends CommonShape {
	constructor() {
		super();
	}
	SetData(data) {
		this.Data = null;
		this.Data = data;
	}
	OnRender() {
		this.EnsureContainerCreated();
		this.drawApi.SetContext(this.Id);
		this.drawApi.ClearAll();
		const data = this.Data;
		const shapeRect = this.ChartContext.Information.ShapeContainerRect;
		if (shapeRect.Width < 1) return;
		if (!isIterable(data)) return;
		let selectSeries = null;
		let legend = this.ChartContext.PluginManager.GetPlugin(PluginMode.Statistics);
		for (const series of data) {
			if (series.Points && series.Points != null) {
				if (legend?.SelectedItem == series.PointId) {
					selectSeries = series;
					continue;
				}
				this.DrawSeries(series);
			}
		}
		if (selectSeries != null) {
			this.DrawSeries(selectSeries);
		}
	}
	DrawSeries(series) {
		let ptArray = this.GetPoints(series);
		if (ptArray != null && ptArray.length > 0) {
			this.Draw(ptArray, series);
			ptArray = null;
		}
	}
	/**绘制 */
	Draw(ptArray, series) {
		this.DrawLines(ptArray, series);
		this.DrawDots(ptArray, series);
	}
	/**绘制线 */
	DrawLines(ptArray, data) {
		if (this.drawApi == null || ptArray == null || ptArray.length == 0 || data == null) return;
		let first = ptArray[0];
		this.drawApi.BeginPath();
		this.drawApi.MoveTo(first.X * this.ZoomFactor, first.Y * this.ZoomFactor);
		for (const d of ptArray) {
			this.drawApi.LineTo(d.X * this.ZoomFactor, d.Y * this.ZoomFactor);
		}
		this.drawApi.Stroke(data.LineColor, data.LineWidth * this.ZoomFactor);
	}
	DrawDots(ptArray, data) {
		if (data.PointType == DataPointShape.None) return;
		if (!this.ChartContext?.Option?.Axis?.ShowDot) return;
		const color = data.LineColor;
		let dotArrays = {
			normal: [],
			red: [],
			yellow: [],
		};
		const shapeRect = this.ChartContext.Information.ShapeContainerRect;
		const left = shapeRect.Left;
		const right = shapeRect.Left + shapeRect.Width;
		const top = shapeRect.Top;
		const bottom = shapeRect.Top + shapeRect.Height;
		for (let i = 0; i < ptArray.length; i++) {
			const d = ptArray[i];
			if (d.X < left || d.X > right || d.Y < top || d.Y > bottom) continue;
			if (d.Flag == 100 || d.Flag == 102) dotArrays.red.push(d);
			else if (d.Flag == 101) dotArrays.yellow.push(d);
			else dotArrays.normal.push(d);
		}
		this.DrawDot(dotArrays.normal, data, color, this.ZoomFactor);
		this.DrawDot(dotArrays.red, data, "#ff0000", this.ZoomFactor, true, 1.5);
		this.DrawDot(dotArrays.yellow, data, "#FFD300", this.ZoomFactor, true, 1.5);
		dotArrays = null;
	}
	/**绘制点 */
	DrawDot(ptArray, data, color, factor, drawBorder = false, size = 1) {
		if (this.drawApi == null || ptArray.length == 0 || data == null) return;
		if (data.PointType !== DataPointShape.None) {
			this.drawApi.Save();
			for (const d of ptArray) {
				this.drawApi.BeginPath();
				this.drawApi.Arc(d.X * factor, d.Y * factor, data.PointSize * factor * size, 0, Math.PI * 2, false);
				this.drawApi.Fill(color, color);
			}
			this.drawApi.Restore();

			if (drawBorder) {
				this.drawApi.Save();
				for (const d of ptArray) {
					this.drawApi.BeginPath();
					this.drawApi.Arc(d.X * factor, d.Y * factor, data.PointSize * factor * size + 2, 0, Math.PI * 2, false);
					this.drawApi.Stroke(store.state.customColor.BackgroundColor, 1);
				}
				this.drawApi.Restore();
			}
		}
	}
	/**获取显示数据 */
	GetPoints(resultData) {
		let calculator = this.ChartContext.CoordinateSystem;
		return calculator.GetPoints(resultData);
	}
	ClearData() {
		this.Data = new Array();
	}
}

export class HLineShapeOperator extends ShapeElement {
	constructor() {
		super();
		this.worker = null;
		this.ZoomFactor = 1.5;
		this.Data = [];
		this.gl = null;
	}
	EnsureContainerCreated() {
		if (this.isDisposed) return;
		const container = this.ChartContext.PluginContainer;
		let element = document.getElementById(this.Id);
		if (element == null && this.gl == null) {
			element = document.createElement("canvas");
			element.setAttribute("id", this.Id);
			element.setAttribute("style", "position:absolute;left:" + this.ChartContext.CoordinateSystem.CanvasLeft + "px;pointer-events:none;");
			container.before(element);
			this.gl = this.getWebGLContext(element);
			this.initShaders(VSHADER_SOURCE, FSHADER_SOURCE);
		}
		if (element) {
			const { width, height } = this.GetContainerRect();
			element.style.width = width + "px";
			element.style.height = height + "px";
			element.width = width * this.ZoomFactor;
			element.height = height * this.ZoomFactor;
		}
		return element;
	}
	getWebGLContext(canvas) {
		let gl = null;
		try {
			// 如果没有webgl上下文，尝试实验版的webgl
			gl = canvas.getContext("webgl") || canvas.getContext("exprimental-wegl");
		} catch { }
		return gl;
	}
	initShaders(vshader, fshader) {
		const gl = this.gl;
		// 分别加载顶点着色器和片段着色器
		const vertexShader = this.loadShader(gl.VERTEX_SHADER, vshader);
		const fragmentShader = this.loadShader(gl.FRAGMENT_SHADER, fshader);

		// 4.创建程序对象
		const program = gl.createProgram();

		// 5.编译过的着色器附加到程序对象中
		gl.attachShader(program, vertexShader);
		gl.attachShader(program, fragmentShader);

		// 6.链接程序对象
		gl.linkProgram(program);

		// 7.调用程序对象
		gl.useProgram(program);
		gl.program = program;
	}
	loadShader(type, source) {
		const gl = this.gl;
		const shader = gl.createShader(type);

		// 2.把着色器代码载入到着色器对象
		gl.shaderSource(shader, source);

		// 3.编译着色器
		gl.compileShader(shader);

		// getShaderParameter 检查编译状态
		const compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
		if (!compiled) {
			const error = gl.getShaderInfoLog(shader);
			console.log("Failed to compile shader: " + error);
			gl.deleteShader(shader);
			return null;
		}

		return shader;
	}
	OnRender() {
		const element = this.EnsureContainerCreated();
		if (element) {
			const info = this.ChartContext.Information;
			const shapeRect = info.ShapeContainerRect;
			const chartRect = info.ChartContainerRect;
			if (shapeRect.Width < 1) return;
			const legend = this.ChartContext.PluginManager.GetPlugin(PluginMode.Statistics);
			const gl = this.gl;
			this.setRate();
			gl.viewport(
				shapeRect.Left * this.ZoomFactor,
				(chartRect.Height - shapeRect.Top - shapeRect.Height) * this.ZoomFactor,
				shapeRect.Width * this.ZoomFactor,
				shapeRect.Height * this.ZoomFactor);
			gl.clearColor(0, 0, 0, 0);
			gl.clear(gl.COLOR_BUFFER_BIT);

			let selectSeries = null;
			for (const data of this.getDrawData()) {
				if (legend?.SelectedItem == data.PointId) {
					selectSeries = data;
					continue;
				}
				this.drawSeries(data);
			}
			if (selectSeries != null) {
				this.drawSeries(selectSeries);
			}
		}
	}
	getDrawData() {
		return this.Data;
	}
	drawSeries(data) {
		const info = this.ChartContext.Information;
		const coordInfo = info.CoordinateInfo;
		const temp = [];
		for (const point of data.Points) {
			temp.push(point.X - coordInfo.XMin);
			temp.push(point.Y - coordInfo.YMin);
		}
		const vertices = new Float32Array(temp);
		const gl = this.gl;
		// 创建buffer对象
		const vertexBuffer = gl.createBuffer();
		// 绑定buffer到缓冲对象上
		gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
		// 向缓冲对象写入数据
		gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.DYNAMIC_DRAW);
		// 从程序对象中获取相应属性
		const a_Position = gl.getAttribLocation(gl.program, "a_Position");
		// 向顶点写入缓冲数据
		gl.vertexAttribPointer(a_Position, 2, gl.FLOAT, false, 0, 0);
		// 使用缓冲数据建立程序代码到着色器代码的联系
		gl.enableVertexAttribArray(a_Position);

		this.setColor(this.hexToRgba(data.LineColor));
		this.setUniformValue("type", 0);
		if (data.DrawType == 1) {
			gl.drawArrays(gl.TRIANGLE_STRIP, 0, temp.length / 2);
		}
		gl.drawArrays(gl.LINE_STRIP, 0, temp.length / 2);
		if (data.PointType > 0 && this.ChartContext?.Option?.Axis?.ShowDot) {
			this.setUniformValue("type", data.PointType);
			this.setUniformValue("pointSize", 6.0);
			gl.drawArrays(gl.POINTS, 0, temp.length / 2);

			//绘制报警点
			const red = [];
			const yellow = [];
			for (const point of data.Points) {
				if (point.Flag == 100 || point.Flag == 102) {
					red.push(point.X - coordInfo.XMin);
					red.push(point.Y - coordInfo.YMin);
				}
				else if (point.Flag == 101) {
					yellow.push(point.X - coordInfo.XMin);
					yellow.push(point.Y - coordInfo.YMin);
				}
			}
			if (red.length > 0) this.drawDots(red, "#ff0000");
			if (yellow.length > 0) this.drawDots(yellow, "#FFD300");
		}
	}
	drawDots(points, color) {
		this.setUniformValue("pointSize", 10.0);
		const gl = this.gl;
		const vertices = new Float32Array(points);
		// 创建buffer对象
		const vertexBuffer = gl.createBuffer();
		// 绑定buffer到缓冲对象上
		gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
		// 向缓冲对象写入数据
		gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.DYNAMIC_DRAW);
		// 从程序对象中获取相应属性
		const a_Position = gl.getAttribLocation(gl.program, "a_Position");
		// 向顶点写入缓冲数据
		gl.vertexAttribPointer(a_Position, 2, gl.FLOAT, false, 0, 0);
		// 使用缓冲数据建立程序代码到着色器代码的联系
		gl.enableVertexAttribArray(a_Position);

		this.setColor(this.hexToRgba(color));
		gl.drawArrays(gl.POINTS, 0, points.length / 2);
	}
	setColor(color) {
		const gl = this.gl;
		const u_FragColor = gl.getUniformLocation(gl.program, "u_FragColor");
		gl.uniform4f(u_FragColor, ...color);
	}
	setRate() {
		const info = this.ChartContext.Information;
		const coordInfo = info.CoordinateInfo;
		this.setUniformValue("xunit", 1 / (coordInfo.XMax - coordInfo.XMin));
		this.setUniformValue("yunit", 1 / (coordInfo.YMax - coordInfo.YMin));
	}
	setUniformValue(key, value) {
		const gl = this.gl;
		const temp = gl.getUniformLocation(gl.program, key);
		gl.uniform1f(temp, value);
	}
	hexToRgba(hex, opacity = 1) {
		if (hex.length == 9) {
			opacity = parseInt("0x" + hex.slice(7, 9)) / 255;
		}
		return [parseInt("0x" + hex.slice(1, 3)) / 255, parseInt("0x" + hex.slice(3, 5)) / 255, parseInt("0x" + hex.slice(5, 7)) / 255, opacity]
	}
	SetData(data) {
		this.Data = new Array();
		for (const d of data) {
			this.Data.push(d);
		}
	}
	OnClear() {
		this.Data = [];
		if (this.gl) this.gl.getExtension('WEBGL_lose_context').loseContext();
		this.gl = null;
	}
	ClearData() {
		this.Data = [];
	}
	GetContainerRect() {
		const container = $("#" + this.ChartContext.ChartContainer.id);
		return {
			width: container.width(),
			height: container.height()
		}
	}
}

export class HLineShapeWorkerOperator extends HLineShapeOperator {
	constructor() {
		super();
		this.worker = null;
		this.ZoomFactor = 1.5;
		this.Data = [];

	}
	EnsureContainerCreated() {
		const container = this.ChartContext.PluginContainer;
		let element = document.getElementById(this.Id);
		if (element == null) {
			element = document.createElement("canvas");
			element.setAttribute("id", this.Id);
			element.setAttribute("style", "position:absolute;left:" + this.ChartContext.CoordinateSystem.CanvasLeft + "px;z-index:1;pointer-events:none;");
			container.before(element);
			this.worker = new performanceWorker();
			const offscreen = element.transferControlToOffscreen();
			this.worker.postMessage({
				msg: "init",
				canvas: offscreen,
				zoomFactor: this.ZoomFactor
			}, [offscreen]);
		}
		const { width, height } = this.GetContainerRect();
		element.style.width = width + "px";
		element.style.height = height + "px";
		this.worker.postMessage({
			msg: "update",
			width: width * this.ZoomFactor,
			height: height * this.ZoomFactor,
		});
		return element;
	}
	OnRender() {
		this.EnsureContainerCreated();
		const info = this.ChartContext.Information;
		const shapeRect = info.ShapeContainerRect;
		const coordInfo = info.CoordinateInfo;

		if (shapeRect.Width < 1) return;
		const legend = this.ChartContext.PluginManager.GetPlugin(PluginMode.Statistics);
		this.worker.postMessage({
			msg: "render",
			shapeRect: shapeRect,
			xmax: coordInfo.XMax,
			xmin: coordInfo.XMin,
			ymax: coordInfo.YMax,
			ymin: coordInfo.YMin,
			showDot: this.ChartContext?.Option?.Axis?.ShowDot || false,
			selectId: legend?.SelectedItem
		});
	}
	SetData(data) {
		this.Data = new Array();
		for (const d of data) {
			this.Data.push(d);
		}
		const info = this.ChartContext.Information;
		const coordInfo = info.CoordinateInfo;
		this.worker.postMessage({
			msg: "setdata",
			datas: this.Data,
			xmax: coordInfo.XMax,
			xmin: coordInfo.XMin,
		});
	}
	OnClear() {
		this.Data = [];
		this.worker?.terminate();
		this.worker = null;
	}
	ClearData() {
		this.Data = [];
	}
	GetContainerRect() {
		const container = $("#" + this.ChartContext.ChartContainer.id);
		return {
			width: container.width(),
			height: container.height()
		}
	}
}
export class CustomShapeOperator extends LineShapeOperator {
	constructor() {
		super();
		this.diluteCount = 3000;
	}
	DrawSeries(series) {
		switch (series.ChartMode) {
			case ChartMode.Performance:
				this.DrawPerformance(series);
				break;
			default:
				this.Draw(this.GetPoints(series), series);
				break;
		}
	}
	Draw(ptArray, series) {
		if (ptArray == null || ptArray.length == 0) return;
		switch (series.ChartMode) {
			case ChartMode.Performance:
				this.DrawPerformance(ptArray, series);
				break;
			default:
				this.DrawLines(ptArray, series);
				this.DrawDots(ptArray, series);
				break;
		}
	}
	DrawPerformance(series) {
		let temp = this.GetDilutePoints(series.Points);
		const coordSystem = this.ChartContext.CoordinateSystem;
		let ptArray = coordSystem.GetSceenPoints(temp.Points);
		if (temp.isDilute) {
			this.DrawContour(ptArray, series);
			this.DrawDots(ptArray, series);
		} else {
			this.DrawLines(ptArray, series);
			this.DrawDots(ptArray, series);
		}
		temp = null;
	}
	DrawContour(ptArray, data) {
		if (this.drawApi == null || ptArray.length < 3 || data == null) return;
		this.drawApi.Save();
		this.drawApi.BeginPath();
		for (let i = 0; i < ptArray.length - 2; i++) {
			this.drawApi.MoveTo(ptArray[i].X * this.ZoomFactor, ptArray[i].Y * this.ZoomFactor);
			this.drawApi.LineTo(ptArray[i + 1].X * this.ZoomFactor, ptArray[i + 1].Y * this.ZoomFactor);
			this.drawApi.LineTo(ptArray[i + 2].X * this.ZoomFactor, ptArray[i + 2].Y * this.ZoomFactor);
		}
		this.drawApi.Fill(data.LineColor, data.LineColor);
		this.drawApi.Restore();
	}
	GetDilutePoints(points) {
		const result = {
			isDilute: false,
			Points: []
		}
		const coordInfo = this.ChartContext.Information.CoordinateInfo;
		let start = -1, end = -1;
		for (let i = 0; i < points.length; i++) {
			if (coordInfo.XMin <= points[i].X && start == -1) {
				start = i;
				break;
			}
		}
		for (let i = points.length - 1; i >= 0; i--) {
			if (coordInfo.XMax >= points[i].X) {
				end = i;
				break;
			}
		}
		let length = end - start + 1;
		if (start > 0) start = start - 1;
		if (end > 0 && end < points.length - 1) end = end + 1;
		if (start == -1 || end == -1) {
			if (start == -1) start = 0;
			if (end == -1) end = points.length - 1;
			result.Points = points.slice(start, end + 1);
			return result;
		}
		result.isDilute = true;
		let diluteRate = this.GetDuliteRate({ count: length - 1, points });
		for (let i = start; i <= end; i = i + diluteRate) {
			let maxIndex = i,
				minIndex = i;
			for (let j = 1; j < diluteRate; j++) {
				if (i + j <= end) {
					if (points[i + j].Y > points[maxIndex].Y) {
						maxIndex = i + j;
					}
					if (points[i + j].Y < points[minIndex].Y) {
						minIndex = i + j;
					}
				}
			}
			if (maxIndex > minIndex) {
				result.Points.push(points[minIndex]);
				result.Points.push(points[maxIndex]);
			} else {
				result.Points.push(points[maxIndex]);
				result.Points.push(points[minIndex]);
			}
		}
		return result;
	}
	GetDuliteRate(param) {
		return (Math.floor(param.count / this.diluteCount) + 1) * 2;
	}
}

export class BarShapeOperator extends CommonShape {
	constructor() {
		super();
	}
	SetData(data) {
		this.Data = data;
	}
	OnRender() {
		this.EnsureContainerCreated();
		const data = this.Data;
		const info = this.ChartContext.Information;
		if (info.ShapeContainerRect.Width < 1) return;
		this.drawApi.ClearAll();
		if (!isIterable(data)) return;
		for (const series of data) {
			if (series.Points && series.Points != null) {
				let ptArray = this.GetPoints(series);
				if (ptArray != null && ptArray.length > 0) {
					const rect = info.ChartList.get(series.PointId).ShapeContainerRect;
					this.drawApi.Save();
					this.drawApi.BeginPath();
					if (this.BarType == BarTypeEnum.Normal) {
						this.drawApi.ClipRect((rect.Left + 2) * this.ZoomFactor, rect.Top * this.ZoomFactor, rect.Width * this.ZoomFactor, rect.Height * this.ZoomFactor);
						this.DrawRectangle(ptArray, series);
					} else {
						this.drawApi.ClipRect((rect.Left + 2) * this.ZoomFactor, (rect.Top - 12) * this.ZoomFactor, rect.Width * this.ZoomFactor, rect.Height * this.ZoomFactor);
						this.DrawCylinder(ptArray, series);
					}
					this.drawApi.Restore();
				}
				ptArray = null;
			}
		}
	}
	/**绘制矩形 */
	DrawRectangle(ptArray, data) {
		const colors = this.ChartContext.CoordinateSystem.Colors;
		for (const d of ptArray) {
			this.drawApi.BeginPath();
			this.drawApi.MoveTo(d.X * this.ZoomFactor, d.Y * this.ZoomFactor);
			this.drawApi.Rectangle(d.X * this.ZoomFactor, d.Y * this.ZoomFactor, d.Width * this.ZoomFactor, d.Height * this.ZoomFactor, colors[data.AlarmLevel]);
		}
	}
	/**绘制圆柱体 */
	DrawCylinder(ptArray, data) {
		const color = this.ChartContext.CoordinateSystem.CylinderDataColor;
		const b = 12 * 2;
		for (const d of ptArray) {
			const x = d.X * this.ZoomFactor + (d.Width * this.ZoomFactor) / 2;
			const y = d.Y * this.ZoomFactor;
			//圆柱体上部椭圆长轴和半轴
			const a = (d.Width * this.ZoomFactor) / 2;
			const h = d.Height * this.ZoomFactor;
			this.drawApi.DrawCylinderEx(x, y, a, b, h, color[data.AlarmLevel]);
		}
	}
	/**获取显示数据 */
	GetPoints(resultData) {
		const calculator = this.ChartContext.CoordinateSystem;
		return calculator.GetPoints(resultData);
	}
	ClearData() {
		this.Data = new Array();
	}
	EnsureContainerCliped() {
		this.drawApi.SetContext(this.Id);
	}
	SetOption(option) {
		this.BarType = option.BarType ? option.BarType : BarTypeEnum.Normal;
	}
}

export class DigitalShapeOperator extends CommonShape {
	constructor() {
		super();
		this.Colors = {
			0: "#00ff03",
			1: "#00ff03",
			2: "#F59435",
			3: "#FF0010",
		};
	}
	SetData(data) {
		this.Data = data;
	}
	OnRender(status) {
		this.EnsureContainerCreated();
		this.drawApi.ClearAll();
		const data = this.Data;
		const info = this.ChartContext.Information;
		this.ChartContext.CoordinateSystem.StopShowBattery = status;
		if (info.ShapeContainerRect.Width < 1) return;
		if (!isIterable(data)) return;
		for (const series of data) {
			if (series.Points && series.Points != null) {
				let ptArray = this.GetPoints(series);
				if (ptArray != null && ptArray.length > 0) {
					this.DrawDigital(ptArray, series.AlarmLevel || 0);
				}
			}
		}
	}
	/**绘制数字表 */
	DrawDigital(ptArray, alarmLevel) {
		for (const d of ptArray) {
			const valueArr = d.Value.split("");
			let splitX = 0;
			for (let i = 0; i < valueArr.length; i++) {
				let opacity = this.SetDigitalOpacity(valueArr[i], 0.1);
				let color = this.Colors[alarmLevel];
				if (valueArr[i] != ".") {
					this.drawApi.DrawDigital(
						(d.Left + splitX) * this.ZoomFactor,
						d.Top * this.ZoomFactor,
						color,
						d.LineWidth * this.ZoomFactor,
						d.DigitalWidth * this.ZoomFactor,
						d.Offset * this.ZoomFactor,
						opacity
					);
					splitX += d.DigitalWidth + d.LineWidth;
				} else {
					this.drawApi.DrawSquare((d.Left + splitX) * this.ZoomFactor, (d.Top + d.DigitalHeight - d.LineWidth) * this.ZoomFactor, d.LineWidth * this.ZoomFactor, color);
					splitX += 2 * d.LineWidth;
				}
			}
			if (d.BatteryValue !== undefined && d.drawBattery) {
				// const { color , text, left, dy, Font } = this.getBatteryInfo(d, d.BatteryValue)
				// this.drawApi.FillText(text, left, dy, color,  Font)
				const { color, resultText, text, left, dy, Font, height } = this.getBatteryInfo(d, d.BatteryValue)
				this.drawApi.FillText(resultText, left, dy, color, Font)
				this.drawApi.FillText(text.slice(resultText.length, text.length), left, dy + 2 * height, color, Font)
			}
		}
	}
	getBatteryInfo(data, value) {
		const { type, num } = Config.battery;
		const { Height, Width } = data.Rect;
		let text = '';
		if (type === 'text') {
			text = value >= num ? i18nGlobal('headerSetting.systemStatus.full') : i18nGlobal('headerSetting.systemStatus.low');
		} else {
			text = value;
		}
		// let FontSize = Height / 6;
		const { FontSize, resultText, height } = this.CaculateSize(Height / 6, text, data.ChartWidth);
		const Font = `normal ${FontSize}px SYHT`;
		const dy = (data.Top + data.DigitalHeight) * this.ZoomFactor + data.LineWidth * this.ZoomFactor + FontSize
		const color = value >= num ? '#00ff03' : '#FF0010';
		const left = data.Left * this.ZoomFactor;

		return {
			color,
			resultText,
			text,
			left,
			Font,
			dy,
			height
		}
	}
	CaculateSize(FontSize, text, ChartWidth) {
		ChartWidth = ChartWidth * 0.9;
		let fontSize = FontSize
		let resultText = text;
		let fistLineSize = getTextSize(fontSize / this.ZoomFactor + 'px', resultText)
		let secondLineSize = getTextSize(fontSize / this.ZoomFactor + 'px', text.slice(resultText.length, text.length))

		if (text.length > 3) {
			let size = getTextSize(fontSize / this.ZoomFactor + 'px', resultText);
			while (size.width > ChartWidth) {
				resultText = resultText.slice(0, resultText.length - 1);
				size = getTextSize(fontSize / this.ZoomFactor + 'px', resultText);
			}
			while ((fistLineSize.width > ChartWidth || secondLineSize.width > ChartWidth) && fontSize > 0) {
				fontSize = fontSize - 5;
				fistLineSize = getTextSize(fontSize / this.ZoomFactor + 'px', resultText)
				secondLineSize = getTextSize(fontSize / this.ZoomFactor + 'px', text.slice(resultText.length, text.length))
			}
		} else {
			ChartWidth = ChartWidth * 0.8;
			let size = getTextSize(fontSize / this.ZoomFactor + 'px', resultText);
			while (size.width > ChartWidth) {
				fontSize = fontSize - 5;
				size = getTextSize(fontSize / this.ZoomFactor + 'px', resultText);
			}
		}
		return {
			FontSize: fontSize,
			resultText,
			height: fistLineSize.height
		}
	}
	/**设置七段数码管的透明度 */
	SetDigitalOpacity(digital, opacity) {
		let style = [];
		switch (digital.toString()) {
			case "0":
				style = [1, 1, opacity, 1, 1, 1, 1];
				break;
			case "1":
				style = [opacity, opacity, opacity, 1, opacity, opacity, 1];
				break;
			case "2":
				style = [1, opacity, 1, 1, 1, 1, opacity];
				break;
			case "3":
				style = [1, opacity, 1, 1, opacity, 1, 1];
				break;
			case "4":
				style = [opacity, 1, 1, 1, opacity, opacity, 1];
				break;
			case "5":
				style = [1, 1, 1, opacity, opacity, 1, 1];
				break;
			case "6":
				style = [1, 1, 1, opacity, 1, 1, 1];
				break;
			case "7":
				style = [1, opacity, opacity, 1, opacity, opacity, 1];
				break;
			case "8":
				style = [1, 1, 1, 1, 1, 1, 1];
				break;
			case "9":
				style = [1, 1, 1, 1, opacity, 1, 1];
				break;
			case "-":
				style = [opacity, opacity, 1, opacity, opacity, opacity, opacity];
				break;
			default:
				style = [opacity, opacity, opacity, opacity, opacity, opacity, opacity];
				break;
		}
		return style;
	}
	/**获取显示数据 */
	GetPoints(resultData) {
		const calculator = this.ChartContext.CoordinateSystem;
		return calculator.GetPointDrawInfos(resultData);
	}
	ClearData() {
		this.Data = new Array();
	}
	EnsureContainerCliped() {
		this.drawApi.SetContext(this.Id);
	}
}

export class TimeLineShapeOperator extends LineShapeOperator {
	constructor() {
		super();
	}
	EnsureContainerCliped() {
		this.drawApi.SetContext(this.Id);
	}
	OnRender() {
		this.EnsureContainerCreated();
		this.drawApi.ClearAll();
		const data = this.Data;
		const info = this.ChartContext.Information;
		if (info.ShapeContainerRect.Width < 1) return;
		if (!isIterable(data)) return;
		for (const series of data) {
			if (series.Points && series.Points != null) {
				this.DrawSeries(series);
			}
		}
	}
	Draw(ptArray, data) {
		this.drawApi.Save();
		const info = this.ChartContext.Information;
		const rect = info.CurrentRect;
		this.drawApi.BeginPath(); //不知道为什么需要设置一下beginpath才能生效
		this.drawApi.ClipRect(rect.Left * this.ZoomFactor, rect.Top * this.ZoomFactor, rect.Width * this.ZoomFactor, rect.Height * this.ZoomFactor);
		const first = ptArray[0];
		this.drawApi.BeginPath();
		this.drawApi.MoveTo(first.X * this.ZoomFactor, first.Y * this.ZoomFactor);
		for (const d of ptArray) {
			this.drawApi.LineTo(d.X * this.ZoomFactor, d.Y * this.ZoomFactor);
		}
		this.drawApi.Stroke(data.LineColor, data.LineWidth * this.ZoomFactor);
		this.drawApi.Restore();
	}
}

export class NavigateLineShapeOperator extends LineShapeOperator {
	constructor() {
		super();
		this.diluteCount = 3000;
	}
	OnRender() {
		super.OnRender();
		this.DrawEndPoint();
	}
	DrawSeries(series) {
		if (series.DrawShape == true) {
			this.DrawCountourSeries(series);
		} else {
			super.DrawSeries(series);
		}
	}
	DrawCountourSeries(series) {
		let temp = this.GetDilutePoints(series.Points, series);
		const coordSystem = this.ChartContext.CoordinateSystem;
		let ptArray = coordSystem.GetSceenPoints(temp.Points);
		const orginBreaks = series.Breaks;
		series.Breaks = temp.Breaks;
		this.DrawContour(ptArray, series);
		series.Breaks = orginBreaks;
		temp = null;
	}
	DrawContour(ptArray, data) {
		if (this.drawApi == null || ptArray.length < 3 || data == null) return;
		if (data.Breaks?.length > 0) {
			let index = 0;
			let breakIndex = 0;
			while (index < ptArray.length) {
				let end = data.Breaks.length > breakIndex ? data.Breaks[breakIndex] : ptArray.length;
				this.drawApi.Save();
				this.drawApi.BeginPath();

				for (let i = index; i < end - 1; i++) {
					this.drawApi.MoveTo(ptArray[i].X * this.ZoomFactor, ptArray[i].Y * this.ZoomFactor);
					this.drawApi.LineTo(ptArray[i + 1].X * this.ZoomFactor, ptArray[i + 1].Y * this.ZoomFactor);
					if (i + 2 < end) this.drawApi.LineTo(ptArray[i + 2].X * this.ZoomFactor, ptArray[i + 2].Y * this.ZoomFactor);
				}
				this.drawApi.Fill(data.LineColor, data.LineColor);
				this.drawApi.Restore();
				index = end;
				breakIndex++;
			}
		}
		else {
			this.drawApi.Save();
			this.drawApi.BeginPath();
			for (let i = 0; i < ptArray.length - 1; i++) {
				this.drawApi.MoveTo(ptArray[i].X * this.ZoomFactor, ptArray[i].Y * this.ZoomFactor);
				this.drawApi.LineTo(ptArray[i + 1].X * this.ZoomFactor, ptArray[i + 1].Y * this.ZoomFactor);
				if (i + 2 < ptArray.length) this.drawApi.LineTo(ptArray[i + 2].X * this.ZoomFactor, ptArray[i + 2].Y * this.ZoomFactor);
			}
			this.drawApi.Fill(data.LineColor, data.LineColor);
			this.drawApi.Restore();
		}
	}
	GetDilutePoints(points, series) {
		const result = {
			Points: [],
			Breaks: []
		}
		if (series.Breaks == null) series.Breaks = [];
		let { start, end, length } = this.getVisiableRange(points);
		if (start == -1 || end == -1 || length <= this.diluteCount) {
			if (start == -1) start = 0;
			if (end == -1) end = points.length - 1;
			result.Points = points.slice(start, end + 1);
			result.Breaks = series.Breaks.filter(b => b >= start && b <= end).map(b => b - start);
			return result;
		}
		const diluteRate = (Math.floor((length - 1) / this.diluteCount) + 1) * 2;
		for (let i = start; i <= end; i = i + diluteRate) {
			let maxIndex = i,
				minIndex = i;
			for (let j = 1; j < diluteRate; j++) {
				if (i + j <= end) {
					if (points[i + j].Y > points[maxIndex].Y) {
						maxIndex = i + j;
					}
					if (points[i + j].Y < points[minIndex].Y) {
						minIndex = i + j;
					}
				}
			}
			if (maxIndex > minIndex) {
				result.Points.push(points[minIndex]);
				result.Points.push(points[maxIndex]);
			} else {
				result.Points.push(points[maxIndex]);
				result.Points.push(points[minIndex]);
			}
		}
		const breaks = series.Breaks.filter(b => b >= start && b <= end);
		this.getContourBreaks(points, breaks, result);
		return result;
	}
	getVisiableRange(points) {
		const coordInfo = this.ChartContext.Information.CoordinateInfo;
		let start = -1, end = -1;
		for (let i = 0; i < points.length; i++) {
			if (coordInfo.XMin <= points[i].X && start == -1) start = i;
			if (coordInfo.XMax >= points[i].X) end = i;
		}
		let length = end - start + 1;
		if (start > 0) start = start - 1;
		if (end > 0 && end < points.length - 1) end = end + 1;
		return { start, end, length };
	}
	getContourBreaks(points, breaks, result) {
		if (breaks.length > 0 && result.Points.length > 0) {
			let range = this.getBreakRange(0, points, breaks, result.Points[0]);
			for (let i = 0; i < result.Points.length - 1; i++) {
				const p = result.Points[i];
				const pNext = result.Points[i + 1];
				if (range == null) break;
				if (p.X > range.x1) {
					range = this.getBreakRange(range.index + 1, points, breaks, p);
				}
				if (p.X == range.x1 || (p.X < range.x1 && pNext.X > range.x2)) {
					result.Breaks.push(i + 1);
					range = this.getBreakRange(range.index + 1, points, breaks, p);
				} else if (pNext.X == range.x2) {
					result.Breaks.push(i);
					range = this.getBreakRange(range.index + 1, points, breaks, p);
				}
			}
		}
	}
	getBreakRange(index, points, breaks, currPoint) {
		for (let i = index; i < breaks.length; i++) {
			if (points[breaks[i]].X > currPoint.X) {
				return {
					x1: breaks[i] == 0 ? points[breaks[i]].X : points[breaks[i] - 1].X,
					x2: points[breaks[i]].X,
					index: i
				}
			}
		}
		return null;
	}
	DrawEndPoint() {
		const fontStyle = " normal 28px Arial";
		const info = this.ChartContext.Information;
		const coordinateSystem = this.ChartContext.CoordinateSystem;
		if (coordinateSystem.ShowEndPoint == false || store.state.browseType === 'app') return;
		const rect = info.ShapeContainerRect;
		const xminText = dayjs(info.CoordinateInfo.XMin).format("YYYY-MM-DD HH:mm:ss.SSS");
		const xminSize = this.drawApi.MeasureText(xminText, fontStyle, fontStyle);
		this.drawApi.FillText(xminText, rect.Left * this.ZoomFactor, (rect.Top + rect.Height) * this.ZoomFactor - xminSize.Height / 2, coordinateSystem.XAxisTextColor, fontStyle);
		const xmaxText = dayjs(info.CoordinateInfo.XMax).format("YYYY-MM-DD HH:mm:ss.SSS");
		const xmaxSize = this.drawApi.MeasureText(xmaxText, fontStyle, fontStyle);
		this.drawApi.FillText(
			xmaxText,
			(rect.Left + rect.Width) * this.ZoomFactor - xmaxSize.Width,
			(rect.Top + rect.Height) * this.ZoomFactor - xmaxSize.Height / 2,
			coordinateSystem.XAxisTextColor,
			fontStyle
		);
	}
}

export class MulitChartLineShapeOperator extends CommonShape {
	constructor() {
		super();
	}
	EnsureContainerCliped() {
		this.drawApi.SetContext(this.Id);
	}
}

export class BandwidthShapeOperator extends CommonShape {
	constructor() {
		super();
		this.Data = [];
	}
	SetData(data) {
		this.Data = data;
	}
	OnRender() {

	}
	ClearData() {
		this.Data = [];
	}
}

export class TrendForecastLineShapeOperator extends LineShapeOperator {
	constructor() {
		super();
	}
	DrawLines(ptArray, data) {
		let sender = this;
		let first = ptArray[0];
		const dashIndex = data.DashIndex;
		const drawApi = this.drawApi;
		drawApi.BeginPath();
		drawApi.MoveTo(first.X * sender.ZoomFactor, first.Y * sender.ZoomFactor);
		drawApi.DrawContext.setLineDash([5, 0]);
		$.each(ptArray, function (i, d) {
			drawApi.LineTo(d.X * sender.ZoomFactor, d.Y * sender.ZoomFactor);
			if (i === dashIndex) {
				drawApi.Stroke(data.LineColor, data.LineWidth * sender.ZoomFactor);
				drawApi.DrawContext.setLineDash([5, 10]);
			}
		});
		drawApi.Stroke(data.LineColor, data.LineWidth * sender.ZoomFactor);
	}
}


export class PanelShapeOperator extends CommonShape {
	constructor() {
		super();
		this.Colors = {
			0: "#00ff03",
			1: "#00ff03",
			2: "#F59435",
			3: "#FF0010",
		};
	}
	SetData(data) {
		this.Data = data;
	}
	EnsureContainerCreated() {
		const container = this.ChartContext.PluginContainer;
		let element = document.getElementById(this.Id);
		if (element == null) {
			element = document.createElement("canvas");
			element.setAttribute("id", this.Id);
			element.setAttribute("style", "position:absolute;left:" + this.ChartContext.CoordinateSystem.CanvasLeft + "px;");
			container.before(element);
		}
		const { width, height } = this.GetContainerRect();
		const ChartList = this.ChartContext.Information.ChartList;
		if (ChartList.size > 0) {
			const chart = ChartList.get([...ChartList.keys()][ChartList.size - 1]);
			const height = (chart.ChartContainerRect.Top + chart.ChartContainerRect.Height + 40);
			element.height = height;
			element.style.height = height / this.ZoomFactor + 'px';
		} else {
			element.height = height * this.ZoomFactor;
		}
		element.width = width * this.ZoomFactor;
		element.style.width = width + "px";
		this.EnsureContainerCliped(this.Id);
		return element;
	}
	OnRender() {
		this.EnsureContainerCreated();
		this.drawApi.ClearAll();
		const data = this.Data;
		const info = this.ChartContext.Information;
		if (info.ShapeContainerRect.Width < 1) return;
		if (!isIterable(data)) return;
		for (const series of data) {
			if (series.Points && series.Points != null) {
				let ptArray = this.GetPoints(series);
				if (ptArray != null && ptArray.length > 0) {
					// this.DrawDigital(ptArray, series.AlarmLevel || 0);
					this.DrawPanel(ptArray, series, series.AlarmLevel || 0);
				}
			}
		}
	}
	GetValueText(value, squareWidth, NumberFontSize) {
		let textSize = getTextSize(`${NumberFontSize}px`, value, 'SYHT')
		while (textSize.width > (squareWidth - 40) && textSize.width > 10 && value.length > 0) {
			value = value.slice(0, -1);
			textSize = getTextSize(`${NumberFontSize}px`, value, 'SYHT')
		}
		return { valueText: value, valueTextSize: textSize }
	}
	DrawPanel(ptArray, point, alarmLevel) {
		const { NumColor, NumberFontSize } = this.ChartContext.Option.Axis;
		const NumFont = `normal ${NumberFontSize * 2}px SYHT`;
		for (const d of ptArray) {
			const Left = d.Left * this.ZoomFactor;
			const ChartWidth = d.ChartWidth * this.ZoomFactor;
			const squareWidth = ChartWidth * 0.7 * 0.5;
			const squareLeft = (ChartWidth * 0.7 - squareWidth) / 2 + ChartWidth * 0.2 + Left;

			// this.drawApi.Rectangle(squareLeft,  d.Top - d.ChartHeight / 2, squareWidth,  d.ChartHeight, NumBackgroundColor)

			const { valueText, valueTextSize } = this.GetValueText(d.Value, squareWidth, NumberFontSize * 2);
			const numTop = d.Top + d.ChartHeight * 0.2;
			let valueColor = NumColor;
			if (alarmLevel === 2 || alarmLevel === 3) valueColor = this.Colors[alarmLevel]
			this.drawApi.FillText(valueText, squareLeft + squareWidth / 2 - valueTextSize.width / 2, numTop, valueColor, NumFont)

			// let differenceTop = 0;
			// const { text, textSize } = this.GetPointNameText(point, squareWidth, TextFontSize * 2);
			// if(NumberFontSize > TextFontSize) {
			// 	differenceTop = (valueTextSize.height - textSize.height) / 4
			// }
			// this.drawApi.FillText(unit, squareLeft + squareWidth + 20, numTop - differenceTop, TextColor, Font)

			// this.drawApi.FillText(text, (squareLeft - textSize.width - 40), numTop - differenceTop, TextColor, Font)
		}
	}
	CaculateSize(FontSize, text, ChartWidth) {
		ChartWidth = ChartWidth * 0.9;
		let fontSize = FontSize
		let resultText = text;
		let fistLineSize = getTextSize(fontSize / this.ZoomFactor + 'px', resultText)
		let secondLineSize = getTextSize(fontSize / this.ZoomFactor + 'px', text.slice(resultText.length, text.length))

		if (text.length > 3) {
			let size = getTextSize(fontSize / this.ZoomFactor + 'px', resultText);
			while (size.width > ChartWidth) {
				resultText = resultText.slice(0, resultText.length - 1);
				size = getTextSize(fontSize / this.ZoomFactor + 'px', resultText);
			}
			while ((fistLineSize.width > ChartWidth || secondLineSize.width > ChartWidth) && fontSize > 0) {
				fontSize = fontSize - 5;
				fistLineSize = getTextSize(fontSize / this.ZoomFactor + 'px', resultText)
				secondLineSize = getTextSize(fontSize / this.ZoomFactor + 'px', text.slice(resultText.length, text.length))
			}
		} else {
			ChartWidth = ChartWidth * 0.8;
			let size = getTextSize(fontSize / this.ZoomFactor + 'px', resultText);
			while (size.width > ChartWidth) {
				fontSize = fontSize - 5;
				size = getTextSize(fontSize / this.ZoomFactor + 'px', resultText);
			}
		}
		return {
			FontSize: fontSize,
			resultText,
			height: fistLineSize.height
		}
	}
	/**获取显示数据 */
	GetPoints(resultData) {
		const calculator = this.ChartContext.CoordinateSystem;
		return calculator.GetPointDrawInfos(resultData);
	}
	ClearData() {
		this.Data = new Array();
	}
	EnsureContainerCliped() {
		this.drawApi.SetContext(this.Id);
	}
}